import { render, staticRenderFns } from "./SubmitBuildingPlan.vue?vue&type=template&id=0e0dbba9"
import script from "./SubmitBuildingPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitBuildingPlan.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports